import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

const requests = {
    fetch: (config: AxiosRequestConfig) =>
        api.get(`/order/modules/all`, config),
};

export default requests;
